export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8484.1966c42d.jpg";